import {
	setDeployType,
	setRaterType,
	setDeployErrorMessage,
	deploy,
} from './assets';

const dispatchToPropsObject: ConfigTester.DispatchToPropsObject = {
	setDeployType,
	setRaterType,
	deploy,
	setDeployErrorMessage,
};

export default dispatchToPropsObject;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/config-tester/index.ts